module.exports = __webpack_public_path__ + "static/media/shaker_01_small.4a893265.jpg";